import isNullish from "utils/isNullish";

import { pageIdentityKey } from "./pageIdentity";

const everywhereOf = (rootState) => rootState.visi.everywhere;

export const historyToken = (rootState) => {
  const everywhere = everywhereOf(rootState);
  return {
    pageKey: pageIdentityKey(everywhere.page),
    mutation: everywhere.conversationMutationEpoch ?? 0,
    pageGeneration: everywhere.pageGeneration ?? 0,
    epoch: everywhere.abandonedConversationEpoch ?? 0,
  };
};

export const conversationsToken = (rootState) => {
  const everywhere = everywhereOf(rootState);
  return {
    mutation: everywhere.conversationMutationEpoch ?? 0,
    pageGeneration: everywhere.pageGeneration ?? 0,
  };
};

export const openConversationToken = (rootState, conversationId) => {
  const everywhere = everywhereOf(rootState);
  return {
    pageGeneration: everywhere.pageGeneration ?? 0,
    epoch: everywhere.abandonedConversationEpoch ?? 0,
    targetMutation: everywhere.conversationMutations?.[conversationId] ?? 0,
    conversationId,
  };
};

export const summaryToken = (rootState) => {
  const everywhere = everywhereOf(rootState);
  return {
    pageKey: pageIdentityKey(everywhere.page),
    contextGeneration: everywhere.contextGeneration ?? 0,
  };
};

export const questionsToken = (rootState) => ({
  pageKey: pageIdentityKey(everywhereOf(rootState).page),
});

const CURRENT = {
  mutation: (everywhere) => everywhere.conversationMutationEpoch ?? 0,
  pageGeneration: (everywhere) => everywhere.pageGeneration ?? 0,
  epoch: (everywhere) => everywhere.abandonedConversationEpoch ?? 0,
  contextGeneration: (everywhere) => everywhere.contextGeneration ?? 0,
};

const isPageKeyStale = (everywhere, token, mode) => {
  if (mode === "lenient" && !token.pageKey) {
    return false;
  }
  return token.pageKey !== pageIdentityKey(everywhere.page);
};

export const staleField = (everywhere, token, { pageKey = "strict" } = {}) => {
  if (!token) {
    return null;
  }
  if (isPageKeyStale(everywhere, token, pageKey)) {
    return "pageKey";
  }
  const named = Object.keys(CURRENT).find(
    (field) =>
      !isNullish(token[field]) && token[field] !== CURRENT[field](everywhere)
  );
  if (named) {
    return named;
  }
  if (
    !isNullish(token.targetMutation) &&
    token.targetMutation !==
      (everywhere.conversationMutations?.[token.conversationId] ?? 0)
  ) {
    return "targetMutation";
  }
  return null;
};
